import { defineMessages } from 'react-intl';

export default defineMessages({
  login: 'Login',
  email: 'E-mail',
  emailRequired: 'E-mail required!',
  password: 'Password',
  passwordRequired: 'Password required!',
  mfa: 'Please enter the code you received by SMS.',
  mfaSms: 'Please enter the code you received by SMS.',
  mfaEmail: 'Please enter the code we sent to your email.',
  mfaTotp: 'Please enter the code from your authenticator app.',
  mfaCode: 'Verification Code',
  mfaCodeRequired: 'Code required!',
  resendCode: 'Resend code',
  tryDifferentMethod: 'Try a different method',
  codeResent: 'A new verification code has been sent.',
  forgotPassword: 'Did you forget your password?',
  loginFailed: 'Login failed. Try again later or check the console for more info.',
  signUp: 'Dont have an account? Sign up here.',
  invalid_grant: 'Invalid email or password.',
  too_many_attempts: 'You have too many failed login attempts. Please contact us.',
  invalid_phone_number: 'Your phone number for verification is invalid. Please contact us.',
  invalid_mfa_code: 'Invalid verification code.',
  invalid_mfa_method: 'The selected verification method is not available.',
});
